export default function mapRadioToBool(delivered: number) {
  switch (delivered) {
    case 2: {
      return true;
    }
    case 3: {
      return false;
    }
    default: {
      return null;
    }
  }
}
